import React from 'react';
import './PresentationSection.css';

const WaitingSection = () => {
  return <div className="moveAndPresentationSection">
    <div className="waitingSet rounded">Waiting for the room creator to make you a player...</div>
  </div>;
};
  
export default WaitingSection;